/**
 * Navigation Setup Component
 * Registers navigation callbacks with navigationService
 * Must be rendered inside Router context
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { navigationService } from '../utils/navigationService';

export const NavigationSetup: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Register React Router navigate function with navigation service
    navigationService.setNavigateCallback((path: string) => {
      navigate(path);
    });
  }, [navigate]);

  // This component doesn't render anything
  return null;
};






